import styled from 'styled-components'

export default styled.a`
color: inherit !important; 
text-decoration: none !important;
`;
